// @ts-strict-ignore
import {Pipe, PipeTransform} from "@angular/core";
import orderBy from "lodash-es/orderBy";
import get from "lodash-es/get";

@Pipe({
	name: "orderBy",
	pure: false,
	standalone: false,
})
export class OrderByPipe implements PipeTransform {
	transform<T>(value: T[], field: string, caseInvariant: boolean = false, order: "asc" | "desc" = "asc"): T[] {
		if (value == null) {
			return null;
		}
		try {
			let iteree = (item) => {
				const val = (get(item, field) ?? "").toString();
				return !caseInvariant ? val : val.toLowerCase();
			};
			return orderBy(value, [iteree], [order]);
		} catch (ex) {
			console.log(ex);
		}
	}
}
